import PropTypes from "prop-types";
import { memo } from "react";
import { FormattedMessage } from "react-intl";
import AccommodationType from "./AccommodationType.jsx";
import Paragraphs from "app/pages/.shared/Paragraphs.jsx";
import MoreDetails from "app/pages/.shared/MoreDetails.jsx";
import "./AccommodationTypes.scss";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

const AccommodationTypes = ({
	headline,
	paragraphs = [],
	accommodationTypes = [],
	facilities = [],
	productUri,
}) => {
	let accommodationTypeNode = accommodationTypes.map((accommodationType, index) => {
		return (
			<div className="accommodation-types__item" key={index}>
				<AccommodationType {...accommodationType} productUri={productUri} />
			</div>
		);
	});

	return (
		<div className="accommodation-types">
			{headline && (
				<Typography
					variant={TYPOGRAPHY_VARIANTS.XL4}
					isBold
					className="accommodation-types__title"
					component="h2"
				>
					{headline}
				</Typography>
			)}

			<div className="accommodation-types__intro">
				<Paragraphs paragraphs={paragraphs} enableHTMLFormatting={true} />
			</div>

			{accommodationTypeNode}

			{facilities.length > 0 && (
				<div className="accommodation-types__details">
					<MoreDetails
						expandedLabel={<FormattedMessage id="product.page.less.details" />}
						collapsedLabel={<FormattedMessage id="product.page.more.details" />}
					>
						<Paragraphs paragraphs={facilities} enableHTMLFormatting />
					</MoreDetails>
				</div>
			)}
		</div>
	);
};

AccommodationTypes.propTypes = {
	headline: PropTypes.string,
	paragraphs: PropTypes.arrayOf(PropTypes.string),
	accommodationTypes: PropTypes.array,
	facilities: PropTypes.arrayOf(PropTypes.string),
	productUri: PropTypes.string,
};

export default memo(AccommodationTypes);
